import React, { useState, useEffect } from "react";
import { width } from "../../../../CustomComponents/DynamicCard/DynamicCardStyles";
import CustomTextInput from "../../../../CustomComponents/CustomtextInput";
import RightArrow from "../../../../../assets/images/RightArrow@2x.png";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../../../CustomComponents/Loader";
import DynamicCard from "../../../../CustomComponents/DynamicCard";
import {
  addLineBreaks,
  handleAmountInputLimitTo2decimal,
  retrieveData,
} from "../../../../../utils";
import logFirebaseEvents from "../../../../LogFirebaseEvents";
import CardHeading from "../../../../CustomComponents/CardHeading";
import { appTheme } from "../../../../../helpers/utils/Utils";
import {
    GET_ALLOCATE_FUND_ACCOUNTNAME,
  GET_ALLOCATE_FUND_FREQUENCIES,
  SAVING_CARD_CODE,
  STATUS_SUCCESS_CODE,
} from "../../../../../network/URLConstants";
import {
  GetApiHeadersWithBearer,
  GetRequest,
} from "../../../../../network/NetworkUtils";
import { withOidcSecure } from "@axa-fr/react-oidc";
import CustomDropdown from "../../../../CustomComponents/CustomDropDown";
import CustomAllocateFundDropdown from "../../../../CustomComponents/CustomAllocateFundDropdown";

const AccountName = ({ cardHeader, cardFooter, onBack, onNext }) => {

  const styleForbuttons = "md:mr-[68px]"
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const kudzuPlusTrue = useSelector((state) => state.kudzuPlusTrue);
  const appThemeData = appTheme(kudzuPlusTrue);
  const [amountError, setAmountError] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [isNext, setIsNext] = useState(false);
  const amount = useSelector((state) => state.allocateFund.Installments);
  const accessToken = useSelector((state) => state.accessToken);
  const [accountName, setAccountName] = useState([]);
  const accountObj = useSelector(state => state.savingGoalAccountTypeObj);
  const [selectedAccountType, setSelectedAccountType] = useState("")
  const cards = useSelector(state => JSON.parse(state.userCards));
  const { AccountType, AccountName, AccountId } = accountObj;
  const SavingGaolName = useSelector(state => state.savingGoals.Name)
  const [selectedAccountBalance, setSelectedAccountBalance] = useState(null);
  const frequency = useSelector(state => state.selectedFrequencyValue);
  const allocatedfund = useSelector(state => state.allocateFund);
  const [lowBalance, setLowBalance] = useState(false);

  const selectedStartdDateCopy = useSelector(state => state.allocateFund.StartDate)
  const selectedEndDate = useSelector(state => state.allocateFund.EndDate)
  const selectedDateCopy = useSelector(state => state.allocateFund.TargetDate);
  
  // const amount = useSelector((state) => state.savingGoals.amount);
  const name = useSelector((state) => state.savingGoals.name);
  
  console.log("SavingGoal" , name)
  console.log("savingGoalName",SavingGaolName )

  const getAccountNames = async () => {
    const deviceId = await retrieveData("updatedDeviceId");
    const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
     const savingsAccount = cards.find(account => account.AccountTypeBit63 == SAVING_CARD_CODE);
    const url = GET_ALLOCATE_FUND_ACCOUNTNAME(savingsAccount.CardKey);
    try {
      const response = await GetRequest(url, headers);
      const responseJson = await JSON.parse(response);
      if (responseJson.ResponseCode === STATUS_SUCCESS_CODE) {
        const arryData = responseJson.Response.Accounts
        let filterName = null;
    

    if (SavingGaolName === null && name !== undefined) {
      filterName = name;
    } else if (name === undefined && SavingGaolName !== null) {
      filterName = SavingGaolName;
    } else if (SavingGaolName !== null && name !== undefined) {
      filterName = SavingGaolName; 
    }

        const filteredData = arryData?.filter(item => item.AccountName !== filterName);
        setAccountName(filteredData);
        dispatch({type:'ACCOUNT_TYPES_DATA',  payload : {accountTypes: filteredData}})
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    getAccountNames();
  }, []);

  
 
// useEffect(()=>{
// alert(accountName)
// },[accountName])
  const handleBackClick = () => {
    logFirebaseEvents(
      "Allocate_Fund",
      "Back_Allocate_Clicked",
      "Back_Allocate_Clicked",
      "",
      ""
    );
    // dispatch({ type: "RESET_ALLOCATE_FUND" });
    onBack("InstallMentAmount")
  };
  const handleNextClick = () => {
    const balanceStatus = checkEligiblity(accountObj.Balance);
    logFirebaseEvents(
      "Allocate_Fund",
      "Next_Allocate_Clicked",
      "Next_Allocate_Clicked",
      "",
      ""
    );
    if(balanceStatus === 'lowBalance') {
      dispatch({
        type: "SHOW_BALANCE_ALERT",
        payload: { showBalanceAlert: true }
      });
      } else {
       if (!amount) setAmountError("Amount Required");
        if (amount && !amountError) onNext("AllocateDateCard");
      }
      dispatch({ type: 'ALLOCATE_FUND', payload: { 'key': "StartDate", 'value': selectedStartdDateCopy } })
      dispatch({ type: 'ALLOCATE_FUND', payload: { 'key': "EndDate", 'value': selectedEndDate } })
      dispatch({ type: 'ALLOCATE_FUND', payload: { 'key': "TargetDate", 'value': selectedDateCopy } })
  };

  const handleOnBlur = (e) => {
    if (!amount) setAmountError("Amount Required");
    else if (amount <= 0) {
      setAmountError("Please enter amount greater than 0");
    } else setAmountError("");
  };

  const amountValidation = () => {
    if (!selectedAccountType) setAmountError("Amount Required");
    else if (selectedAccountType <= 0) {
      setAmountError("Please enter amount greater than 0");
    } else {
      setAmountError(null);
      setIsNext(true);
    }
  };
  useEffect(() => {
    if (selectedAccountType) amountValidation();
    if (!selectedAccountType) setIsNext(false);
  }, [selectedAccountType]);

  const setFrequencyFun = (value) => {
    // alert(JSON.stringify(selectedAccountType));
    if (value?.ACHAccountInternalId == 0) {
      
      const internalAccount = cards.find((card) => card.CardKey === value?.AccountId);
      dispatch({
        type: "ACCOUNT_BALANCE",
        payload: {accountBalance: internalAccount?.Balance.toFixed(2) },
      });
      dispatch({
        type: "IS_INTERNAL_ACCOUNT",
        payload: {isInternalAccount: false }
      })
    } else {
      dispatch({
        type: "ACCOUNT_BALANCE",
        payload: {accountBalance: 0 },
      });
      dispatch({
        type: "IS_INTERNAL_ACCOUNT",
        payload: {isInternalAccount: false }
      })

    }
    dispatch({type: "GOAL_CARD_TYPE", payload: {goalCardType: value.AccountType}});
    checkAvailableBalanceForKudzuCard(value);
    setSelectedAccountType(value)
    dispatch({  type: "SAVING_GOAL_ACCOUNT_TYPE_OBJ",   payload: { savingGoalAccountTypeObj : value },  });
};
useEffect(()=>{
if (AccountName) {
  setIsNext(true)
}else{
  setIsNext(false)
}
},[AccountName])

function checkAvailableBalanceForKudzuCard(accountType) {
  var arrCards = cards;
  var card = accountType        
  for (var index = 0; index < arrCards.length; index++) {            
      if (card.AccountId == arrCards[index].CardKey){
          console.log(arrCards[index].Balance)
          card.Balance = arrCards[index].Balance.toFixed(2)
      }
  }
  setSelectedAccountBalance(card)
}

const checkEligiblity = (selectedAccbalance) => {
  debugger;
  if(frequency.Code === 'OT' || frequency.Code === 'DY') {
      let amount = allocatedfund.Installments;
      const amt = parseFloat(amount)

      const balance = parseFloat(selectedAccountBalance != null ? selectedAccountBalance.Balance : selectedAccbalance )

      if(amt > balance) {
          return('lowBalance')
      }
  }
}


 
  const children = () => {
    return (
      <>
        {/* {cardHeader} */}
        <div
          className="sm:w-[auto] w-[257px] font-serif-pro font-[400] lg:text-[26px] md:text-[24px]
        sm:text-[22px] text-[25px] leading-[32px] sm:leading-[30px] md:leading-[36px] 
            text-[var(--text-clrs)] mt-6 sm:mx-0 mx-4"
        >
          {t("create_account_headin1")}
          <span className="text-[var(--text-body-clrs)]">
            {addLineBreaks(t("Allocate_Fund_Account_Text_Update"))}
          </span>
        </div>

        <div className="w-full flex justify-center">
          <div className="sm:w-[80%] w-full md:mb-32">
            {/* BODY */}
            <div className="md:my-20 sm:my-16 mt-10 v sm:mx-0 mx-4">
              <div className="sm:w-[80%] flex flex-col justify-center">
                <CustomAllocateFundDropdown
                  options={
                    accountName.length > 0
                      ? accountName
                      : [{ Name: t("no_linked_acccounts") }]
                  }
                  title={t("Accounts")}
                  onSelect={setFrequencyFun}
                  selectedAccountType={accountObj}
                  hrbg="bg-dropdown-sky"
                //   error={transferFromError}
                />
              </div>
            </div>
          </div>
        </div>
        {/* FOOTER */}

        {cardFooter(handleBackClick, handleNextClick, "", "", isNext,styleForbuttons)}
      </>
    );
  };
  return (
    <>
      <DynamicCard
        header={false}
        CardRadius={true}
        cardWidth={width.homeCard}
        HeaderRadius={true}
        isWhite={appThemeData.isWhiteBgForCard}
        isDarkForKudzu={appThemeData.isDarkBgForCard}
        backgroundColor={"--cardHeading-bg"}
        HeaderContent={
          <>
            <CardHeading heading={t("Allocate_Funds")} />
          </>
        }
        footer={true}
      >
        {children()}
      </DynamicCard>
      {isLoading && <Loader />}
    </>
  );
};

export default withOidcSecure(AccountName);
